"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFixedPrecisionTwo = exports.toDollar = exports.sanitizeValues = exports.numericDateFormatter = exports.goToDashboardLCPS = exports.formatPhoneNumber = exports.formUtils = exports.dateFormatter = exports.REGEX_DIGITS_AMOUNT = exports.REGEX_DIGITS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _uiMoney = _interopRequireDefault(require("ui-money"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var dateConfig = {
  month: 'long',
  day: 'numeric',
  year: 'numeric'
};
var dateFormatter = new Intl.DateTimeFormat('en-US', dateConfig);
exports.dateFormatter = dateFormatter;
var numericDateFormatter = new Intl.DateTimeFormat('en-US');
exports.numericDateFormatter = numericDateFormatter;
var formatPhoneNumber = function formatPhoneNumber(input) {
  var str = input;
  if (!str || Number.isNaN(str)) throw new Error('Must be a number');
  if (typeof str !== 'string') str = str.toString();
  if (str.length === 10) {
    return str.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  return '';
};
exports.formatPhoneNumber = formatPhoneNumber;
var toFixedPrecisionTwo = function toFixedPrecisionTwo(value) {
  return value && Number.parseFloat(value).toFixed(2);
};
exports.toFixedPrecisionTwo = toFixedPrecisionTwo;
var toDollar = function toDollar(value) {
  return value && new _uiMoney.default(value).format(2);
};
exports.toDollar = toDollar;
var REGEX_DIGITS = /\d+/;
exports.REGEX_DIGITS = REGEX_DIGITS;
var REGEX_DIGITS_AMOUNT = /[\d]*[.]?[\d]{0,2}/;
exports.REGEX_DIGITS_AMOUNT = REGEX_DIGITS_AMOUNT;
var sanitizeValues = function sanitizeValues(val, REGEX) {
  var matchRes = val.match(REGEX);
  if (!val || !matchRes) {
    return '';
  }
  return matchRes.join('');
};
exports.sanitizeValues = sanitizeValues;
var goToDashboardLCPS = function goToDashboardLCPS() {
  window.location.assign('/patientsolutions/dashboard');
};
exports.goToDashboardLCPS = goToDashboardLCPS;
var formUtils = {
  prepareFormData: function prepareFormData(data, action) {
    if (action === 'delete') {
      return {
        refundId: data.refundId
      };
    }
    var formData = _objectSpread({}, data);
    delete formData.netRefund;
    delete formData.fullRefund;
    delete formData.totalCharges;
    if (action === 'save') {
      delete formData.authorizedByProvider;
    }
    return formData;
  },
  configRequest: function configRequest(_ref) {
    var isDelete = _ref.isDelete,
      inProcess = _ref.inProcess,
      actionsUrls = _ref.actionsUrls;
    if (isDelete) {
      return actionsUrls.delete;
    }
    return inProcess ? actionsUrls.patch : actionsUrls.post;
  }
};
exports.formUtils = formUtils;
